import React, { Suspense, lazy } from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';
import Login from './pages/Login';
import Dashboard from './pages/Dashboard';
import Users from './pages/Users';
import Tests from './pages/Tests';
import News from './pages/News';
import DailyTasks from './pages/DailyTasks';
import Taqdimnoma from './pages/Taqdimnoma';
import Books from './pages/Books';
import Downloads from './pages/Downloads';
import Reminders from './pages/Reminders';
import LawDocuments from './pages/LawDocuments';
import WorkZones from './pages/WorkZones';
import Attendance from './pages/Attendance';
import Messages from './pages/Messages';
import Districts from './pages/Districts';
import Meetings from './pages/Meetings';
import Mahkumlar from './pages/Mahkumlar';
import SayyorSud from './pages/SayyorSud';
import Nazorat from './pages/Nazorat';
import KunlikHisobot from './pages/KunlikHisobot';
import Sos from './pages/Sos';
import IlovaVersiyalari from './pages/IlovaVersiyalari';
import Layout from './components/Layout';
import { probatsiyachimi } from './foydalanuvchi';
import { tr } from './til';

// Tahlil diagramma kutubxonasini (recharts) olib keladi — u ~110 KB.
// Sahifa kamdan-kam ochilgani uchun alohida yuklanadi: qolgan bo'limlar
// avvalgidek tez ochilaveradi.
const Tahlil = lazy(() => import('./pages/Tahlil'));

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem('token');
  return token ? children : <Navigate to="/login" />;
};

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/login" element={<Login />} />
        <Route path="/" element={<PrivateRoute><Layout /></PrivateRoute>}>
          {/* Probatsiya xodimiga Dashboard yopiq — u to'g'ridan-to'g'ri
              o'z reyestriga tushadi. */}
          <Route index element={probatsiyachimi() ? <Navigate to="/mahkumlar" replace /> : <Dashboard />} />
          <Route path="mahkumlar" element={<Mahkumlar />} />
          <Route path="sayyor-sud" element={<SayyorSud />} />
          <Route path="nazorat" element={<Nazorat />} />
          <Route path="kunlik-hisobot" element={<KunlikHisobot />} />
          <Route path="tahlil" element={
            <Suspense fallback={<div style={{ padding: 24, color: '#666' }}>{tr("Yuklanmoqda...")}</div>}>
              <Tahlil />
            </Suspense>
          } />
          <Route path="sos" element={<Sos />} />
          <Route path="ilova-versiyalari" element={<IlovaVersiyalari />} />
          <Route path="users" element={<Users />} />
          <Route path="tests" element={<Tests />} />
          <Route path="news" element={<News />} />
          <Route path="daily-tasks" element={<DailyTasks />} />
          <Route path="taqdimnoma" element={<Taqdimnoma />} />
          <Route path="books" element={<Books />} />
          <Route path="downloads" element={<Downloads />} />
          <Route path="reminders" element={<Reminders />} />
          <Route path="law-documents" element={<LawDocuments />} />
          <Route path="attendance" element={<Attendance />} />
          <Route path="work-zones" element={<WorkZones />} />
          <Route path="messages" element={<Messages />} />
          <Route path="districts" element={<Districts />} />
          <Route path="meetings" element={<Meetings />} />
        </Route>
      </Routes>
    </Router>
  );
}

export default App;